export default [
  {
    path: '/',
    name: 'set-user',
    component: () => import('@/views/pages/SetUser.vue'),
    meta: {
      noOrganizationAccess: true,
      layout: 'full',
    },
  },
]
